import React, { useState } from "react";
import { useDispatch } from "react-redux";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import ClearIcon from "@mui/icons-material/Clear";

import QueryService from "services/QueryService";
import { getItem } from "store/operations";

const AddNewTagDialog = ({ stackId, tagType, open, onClose, callback }) => {
  const [name, setName] = useState("");

  const dispatch = useDispatch();

  const addNewTag = async () => {
    const tag_id = await QueryService.createTopicTag(stackId, name);
    dispatch(getItem(stackId)).then((rv) => {
      if (callback) {
        callback(tag_id);
      }
      onClose();
    });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Name the new {tagType}
          <IconButton onClick={onClose} size="large">
            <ClearIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <TextField
          variant="standard"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth />
      </DialogContent>
      <DialogActions>
        <Button onClick={addNewTag} color="primary" disabled={!name}>
          Create
        </Button>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddNewTagDialog;
